import styled from 'styled-components';

import { media } from '../../utils/mediaQueries';

interface GridWrapperProps {
  $display?: 'grid' | 'inline-grid';
  $gridColumns?: string;
  $gridTemplateRows?: string;
  $gap?: string;
  $justifyContent?:
    | 'start'
    | 'end'
    | 'center'
    | 'stretch'
    | 'space-between'
    | 'space-around'
    | 'space-evenly'
    | 'normal';
  $itemAlign?: string;
  $margin?: string;
  $contain?: boolean;
  $height?: string;
  $maxWidth?: string;
}

export const GridWrapper = styled.div<GridWrapperProps>`
  display: ${({ $display }) => $display || 'grid'};
  grid-template-columns: ${({ $gridColumns }) => $gridColumns || 'auto'};
  grid-template-rows: ${(props) => props.$gridTemplateRows || 'auto'};
  gap: ${(props) => props.$gap || 0};
  justify-content: ${(props) => props.$justifyContent || 'start'};
  align-items: ${({ $itemAlign }) => $itemAlign ?? 'normal'};
  margin: ${(props) => props.$margin || 0};
  width: 100%;
  height: ${({ $height }) => $height ?? 'auto'};
  max-width: ${({ $maxWidth }) => $maxWidth ?? '100%'};

  ${media.tabletDown} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${media.mobile} {
    grid-template-columns: 1fr;
  }
`;
